<div class="branchesMap">
<div class="xvideoWrapper">
<div id="locationsVideo" class="locationsVideoWrapper">
</div>
<div class="volumeButtons">
  <ng-container *ngIf="showMuteBtn">
<button class="redBtn" mat-raised-button (click)="muteVolume()" id="muteVolume"><span class="material-icons">
  volume_up
  </span> Mute</button>
  </ng-container>
  <ng-container *ngIf="showUnmuteBtn">
 <button class="greenBtn" mat-raised-button (click)="unmuteVolume()" id="unmuteVolume"><span class="material-icons">
  volume_off
  </span> Unmute</button>
  </ng-container>
</div>
</div>

</div>
